import styled from "styled-components";

export const Label = styled.label`
  color: var(--shape);
  display: flex;
  gap: 0.5rem;
  text-align: right;
  width: 100%;
  cursor: pointer;
`